export default function BannerImage(props) {
  return (
    <div className="w-full">
      <img src={props.image} className="object-center w-full max-sm:h-52" alt="" />
    </div>
  );
}
